// eslint-disable-next-line @typescript-eslint/no-var-requires
const { parseNumbers, parseBooleans, firstCharLowerCase } = require('xml2js').processors;
export const appName = 'oövv';
export const dateFormat = 'DD.MM.YYYY';
export const xml2JsonConfig = { explicitArray: false, ignoreAttrs: true, valueProcessors: [parseNumbers, parseBooleans], tagNameProcessors: [firstCharLowerCase] };
export const fileTypes = "image/jpg,image/jpeg,image/png,image/bmp";
export const maxFileSize = 5*1024*1000;
export const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
export const timeZoneOffset = new Date().getTimezoneOffset();
export const currency = "EUR";